import React from 'react';

import { getValueWithEllipsis } from '@/src//util/strings';
import SiteAvatar from '@/src/components/common/Avatar/SiteAvatar/SiteAvatar';

const RECIPIENT_DISPLAY_MAXLENGTH = 20;

export const getDisplayAvatar = (
  tag,
  selectorKey,
  width = '24px',
  height = '24px',
  fontSize = '12px'
) => {
  if (tag.role && tag.role.includes('External')) {
    return null;
  }

  // If not member, no alis is defined (label = alias)
  if (tag.value !== tag.label) {
    return (
      <SiteAvatar
        key={`${selectorKey}_${tag.value}`}
        id={`${selectorKey}_${tag.value}`}
        className={tag.bounce && 'tw-opacity-[0.4]'}
        disableTooltip={true}
        name={`${tag.label}`}
        avatar={tag.avatar}
        width={width}
        height={height}
        fontSize={fontSize}
      />
    );
  }

  return null;
};

export const getFullLabel = (tag) => {
  if (tag.role && tag.role.includes('External')) {
    return tag.value;
  }

  if (tag.bounce) {
    return (
      <>
        {tag.value !== tag.label ? `${tag.label} <${tag.value}>` : tag.label}
        <span className={'!tw-text-cfo-red-400'}>(bounced email address)</span>
      </>
    );
  }

  return tag.value !== tag.label ? `${tag.label} <${tag.value}>` : tag.label;
};

export const getDisplayLabel = (tag) => {
  if (tag.role && tag.role.includes('External')) {
    return getValueWithEllipsis(tag.value, RECIPIENT_DISPLAY_MAXLENGTH);
  }

  return getValueWithEllipsis(tag.label, RECIPIENT_DISPLAY_MAXLENGTH);
};

export const getBounce = (tag) => {
  return tag.bounce || false;
};
